import ArticleFixe from './ArticleFixe'

export default ArticleFixe
